import React from "react";
import { Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { HiOutlineHome } from "react-icons/hi2";
import {
  PiStudentLight,
} from "react-icons/pi";
import { MdOutlineClass, MdOutlineSubject, MdOutlineAttachMoney, } from "react-icons/md";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";


export default function SideNavbar({
  collapsed,
  setCollapsed,
  mobileNavOpen,
  setMobileNavOpen,
}) {
  const closeMobile = () => setMobileNavOpen(false);

  return (
    <aside
      className={`sidebar ${collapsed ? "collapsed" : ""} ${mobileNavOpen ? "mobile-open" : ""
        }`}
    >
      <div className="sidebar-mobile-close">
        <button onClick={closeMobile}>×</button>
      </div>

      <div className="sidebar-header text-light d-flex align-items-center justify-content-between">
        {!collapsed && <h6 className="mb-0 fw-bold">Menu</h6>}
        <button
          className="toggle-btn"
          style={{ background: "none", border: "none", color: "white" }}
          onClick={() => setCollapsed(!collapsed)}
        >
          {collapsed ? <FiChevronRight size={20} /> : <FiChevronLeft size={20} />}
        </button>
      </div>

      <div className="sidebar-menu">
        <Nav className="flex-column sidebar-nav">
          {/* Home */}
          <Nav.Link as={NavLink} to="/sadmin/home" onClick={closeMobile}>
            <HiOutlineHome size={18} /> {!collapsed && "Home"}
          </Nav.Link>

          {/* Student */}
          <Nav.Link as={NavLink} to="/sadmin/institute" onClick={closeMobile}>
            <PiStudentLight size={18} /> {!collapsed && "Institute"}
          </Nav.Link>


          {/* Class & Section */}
          <Nav.Link as={NavLink} to="/sadmin/classandsection" onClick={closeMobile}>
            <MdOutlineClass size={18} /> {!collapsed && "Class & Section"}
          </Nav.Link>

          {/* Subject */}
          <Nav.Link as={NavLink} to="/sadmin/subject" onClick={closeMobile}>
            <MdOutlineSubject size={18} /> {!collapsed && "Subject"}
          </Nav.Link>



          {/* Fees */}
          <Nav.Link as={NavLink} to="/sadmin/fees" onClick={closeMobile}>
            <MdOutlineAttachMoney size={18} /> {!collapsed && "Fees"}
          </Nav.Link>






        </Nav>
      </div>
    </aside>
  );
}
